import { Injectable } from '@angular/core';
import { ApiService } from '@app/shared/services/api.service';
import {
  PersonalLoanApplicationAgentNoteApi,
  LDCLPBPPublicApiModelsLoanApplicationsAgentNoteCreateAgentNoteRequest,
  LDCLPBPPublicApiModelsLoanApplicationsAgentNoteCreateAgentNoteResponse
} from '../../../../../generated/internalApi';
import { SessionService } from '@app/shared/services';
import { Observable, throwError } from 'rxjs';

@Injectable()
export class AgentNoteService extends ApiService {
  private authorization: string;

  constructor(private agentService: PersonalLoanApplicationAgentNoteApi, public sessionService: SessionService) {
    super(sessionService);
    this.authorization = this.sessionService.data.authData.token;
  }

  public createAgentNote(
    loanApplicationGuid: string,
    request: LDCLPBPPublicApiModelsLoanApplicationsAgentNoteCreateAgentNoteRequest
  ): Observable<LDCLPBPPublicApiModelsLoanApplicationsAgentNoteCreateAgentNoteResponse> {

    return this.agentService.personalLoanApplicationAgentNoteCreateAgentNote(loanApplicationGuid, request, this.authorization)
      .map(res => res.data)
      .catch(err => {
        console.error(err);
        return throwError(err);
      });
  }
}
